export type SubscriptionsStatus =
	| "active"
	| "canceled"
	| "incomplete"
	| "incomplete_expired"
	| "past_due"
	| "trialing"
	| "unpaid"
	| "all";

interface Subscription {
	id: string;
	status: SubscriptionsStatus;
	businessProfileId: number;
	quantity: number;
}

export class SubscriptionModel implements Subscription {
	id: string;
	status: SubscriptionsStatus;
	businessProfileId: number = 0;
	quantity: number;

	constructor(id: string, status: SubscriptionsStatus, quantity: number) {
		this.id = id;
		this.status = status;
		this.quantity = quantity;
	}

	get quantityIfActiveStatus() {
		return this.status === "active" ? this.quantity : 0;
	}

	static generateFromAPI(data: any) {
		return new SubscriptionModel(data.id, data.status, data.quantity);
	}

	static generateFromObject = (data: Subscription): SubscriptionModel => {
		return new SubscriptionModel(data.id, data.status, data.quantity);
	};

	static generateEmpty = (): SubscriptionModel => {
		return new SubscriptionModel("", "all", 0);
	};
}
